// Dependencies imports
import React, {useState} from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import swal from 'sweetalert';
// Local imports
import { Constants } from "../../../config/constants";

import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData, awsSignOut } from "../../../redux/auth/authSlice";
import config from "../../../config/aws-exports";
import { API } from "aws-amplify";

// Style imports
import Delete from "./DeleteAssessmentAndAssignment.module.scss";

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      heigth: "100%",
      alignItems: "center",
      justifyContent: "center",
      background: "transparent"
    },
  }));

const DeleteAssesAndAssign = (props) => {
    let {  handleCloseDelete, type, getQuiz, courseId, assessId} = props;
    const [spin, setSpin] = useState(false);
  const classes = useStyles();
  let userDetails = useSelector(authData);

console.log("User Details", userDetails);
console.log("Course ID", courseId);
console.log("Asses ID", assessId);

// API to delete Assessments
  const onAssessmentDelete = async() => {
    // setname(name)
    // alert(event.target.files[0]);
    setSpin(true);
    const bodyParam = {
      body: {
        quiztype:"assess",
        cid: courseId,
        id: assessId,
        action: "delete",
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.UPDATE_ASSESSMENT,
        bodyParam
      );
      console.log("response", JSON.stringify(response));
      swal({
        title: "Success",
        text: "Assessment Deleted successfully",
        icon: "success",
        dangerMode: false,
        closeOnClickOutside: false,
      })
        .then(willDelete => {
          if (willDelete) {
            handleCloseDelete();
            setSpin(false);
            window.location.reload();
          }
        });
    } catch (error) {
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      })
        .then(willDelete => {
          if (willDelete) {
            handleCloseDelete();
            setSpin(false);
            window.location.reload();
          }
        });
    }
    console.log("Mount"); 
};

// API to delete Assignments
const onAssignmentsDelete = async() => {
  setSpin(true);
  const bodyParam = {
    body: {
      quiztype:"assign",
      cid: courseId,
      id: assessId,
      action: "delete",
      oid: config.aws_org_id,
    },
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  try {
    const response = await API.post(
      config.aws_cloud_logic_custom_name,
      Constants.UPDATE_ASSESSMENT,
      bodyParam
    );
    swal({
      title: "Success",
      text: "Assignment Deleted successfully",
      icon: "success",
      dangerMode: false,
      closeOnClickOutside: false,
    })
      .then(willDelete => {
        if (willDelete) {
          handleCloseDelete();
        setSpin(false);
        window.location.reload();
        }
      });
  } catch (error) {
    swal({
      title: "Oooops!",
      text: "Soomthing wrong!",
      icon: "warning",
      dangerMode: true,
      closeOnClickOutside: false,
    })
      .then(willDelete => {
        if (willDelete) {
          handleCloseDelete();
          setSpin(false);
          window.location.reload();
        }
      });
  }
  console.log("Mount"); 
};

   console.log("type", type);
    return(
        <div>
      {spin === false ?
        <div className={Delete.mainpopup}>
          <div className={Delete.form}>
            <form>
              {type === "Assessment" ? <div className={Delete.header}>Are you sure you want to Delete this Assessment ?</div> : <div className={Delete.header}>Are you sure you want to Delete this Assignment ?</div>}
              <div className={Delete.buttonholder}>
                {type === "Assessment" ? <button className={Delete.submit} onClick={() => {onAssessmentDelete()}}>Yes</button> : <button className={Delete.submit} onClick={() => {onAssignmentsDelete()}}>Yes</button>}
                <button className={Delete.cancel} onClick={handleCloseDelete}>NO</button>
              </div>
            </form>
          </div>
        </div> : <div className={classes.root}>
          <CircularProgress style={{ color: config.main_color_1 }} /></div>}
    </div>
    );
};

export default DeleteAssesAndAssign;

